import { FormationDetailProps } from '@/types/formation';

export const catecFormation: FormationDetailProps = {
  id: '23',
  title: 'Formation Initiale CATEC®',
  description: 'Certificat d\'Aptitude à Travailler en Espaces Confinés dans les métiers de l\'eau et de l\'assainissement R472 R447',
  duration: '14h (2 jours)',
  category: 'Sécurité',
  imageSrc: '/images/formations/catec.webp',
  slug: 'catec',
  reference: 'R472 R447',
  price: 'Sur devis – nous contacter',
  habilitation: 'Sous habilitation N° H30797/2023/Catec-1/0/16',
  
  // Détails supplémentaires
  objectives: [
    'Préparer les participants à intervenir en toute sécurité dans des espaces confinés',
    'Maîtriser les procédures préalables à toute intervention',
    'Utiliser et vérifier les équipements de sécurité',
    'Obtenir les certificats CATEC® Surveillant et/ou Intervenant'
  ],
  
  targetAudience: 'Salariés, surveillants et intervenants amenés à travailler dans les milieux de l\'eau potable et de l\'assainissement',
  
  prerequisites: [
    'Notions sur la signalisation de chantier',
    'Maîtrise de l\'usage des contrôleurs d\'atmosphère',
    'Utilisation des appareils respiratoires et des EPI',
    'Attestation des prérequis par l\'employeur ou réalisés par un centre habilité',
    'Tenue de travail et EPI obligatoires'
  ],
  
  program: [
    {
      title: 'Théorie',
      items: [
        'Réglementation et recommandation R472 de la CNAM',
        'Risques spécifiques des espaces confinés',
        'Procédures préalables à l\'intervention',
        'Moyens et codes de communication'
      ]
    },
    {
      title: 'Pratique',
      items: [
        'Vérification des équipements de sécurité',
        'Mise en situation en espace confiné',
        'Procédures d\'évacuation',
        'Utilisation des détecteurs de gaz et autres équipements'
      ]
    }
  ],
  
  evaluationMethods: [
    'Questionnaire de positionnement initial',
    'Exercices pratiques en conditions réelles',
    'QCM d\'évaluation des acquis',
    'Grilles d\'évaluation selon le référentiel CATEC',
    'Évaluation de satisfaction à chaud'
  ],
  
  certification: 'Carte CATEC® Intervenant et/ou Surveillant délivrée par l\'INRS - Validité : 3 ans',
  
  pedagogicalMethods: [
    '40% théorie, 60% pratique',
    'Exposés didactiques, vidéos, débats, études de cas',
    'Mises en situation réelles dans ouvrages sécurisés',
    'Simulations avec détecteurs, harnais, tripodes, ventilateurs, etc.',
    'Suivi des recommandations R447 et R472'
  ],
  
  accessibilityCriteria: 'La formation est accessible aux personnes en situation de handicap. Merci de nous contacter en amont pour anticiper tout aménagement nécessaire.',
  
  registrationProcess: [
    'Inscription par email',
    'Délai d\'accès basé sur un agenda interne à l\'entreprise',
    'Inscription possible jusqu\'à 15 jours avant la session'
  ],
  
  intervenant: 'Les formations CATEC sont réalisées par un organisme habilité par l\'INRS sous l\'habilitation N° H30797/2023/Catec-1/0/16',
  
  formatterInfo: {
    name: 'Sébastien DAVRAINVILLE',
    phone: '06.22.61.04.09',
    email: 'sdpsiformation@orange.fr',
    website: 'www.sdpsiformation.fr'
  }
};

export default catecFormation;
